export default `
varying vec2 vUv;
uniform float time;
uniform float deltaTime;
uniform float fade;
uniform vec2 mouse;
uniform bool isMouse;
uniform sampler2D buffer;
uniform vec2 resolution;

void main() {
	float asp = resolution.x / resolution.y;
	vec2 ln = vUv - mouse;
	float zoom = resolution.y / 699.;
	ln.x *= asp;
	ln *= zoom;
    float cir = smoothstep(.065, 0.045, length(ln));
	cir *= fade;
	#if defined(OFFSET_TOP)
		vec2 bp = vec2(vUv.x, vUv.y - .1 * deltaTime);
	#elif defined(OFFSET_BOTTOM)
		vec2 bp = vec2(vUv.x, vUv.y + .1 * deltaTime);
	#else
		vec2 bp = vUv;
	#endif
	float buf = texture2D(buffer, bp).x;
	float nb = buf - deltaTime;
	float newBuf = clamp(cir > nb ? cir : nb, 0., 1.);
	gl_FragColor = vec4(newBuf);
}
`